import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import NumericInput from '../../../components/Formik/Forms/NumericInput'
import SelectInput from '../../../components/Formik/Forms/SelectInput'
import SwitchInput from '../../../components/SwitchInput'
import TextInput from '../../../components/Formik/Forms/TextInput'
import { CenarioMetadataResponse } from '../types'

interface Props {
  metadata: CenarioMetadataResponse | null
  tipo: string
}

export function ValoresCenario({ metadata, tipo }: Props) {
  const chaves =
    metadata?.tipos[tipo as keyof typeof metadata.tipos]?.chaves ?? []

  if (!tipo || !chaves.length) {
    return null
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5">Valores do cenário</Typography>
      </Grid>
      {chaves.map(chave => {
        const name = `valores.${chave.chave}`

        if (chave.dominio.tipo === 'numero') {
          return (
            <Grid item xs={12} sm={3} key={chave.chave}>
              <NumericInput
                name={name}
                label={chave.label}
                maxValue={chave.dominio.max}
              />
            </Grid>
          )
        }

        if (chave.dominio.tipo === 'codigo') {
          const options = Object.entries(chave.dominio.valores).map(
            ([value, label]) => ({ value, label })
          )
          return (
            <Grid item xs={12} sm={3} key={chave.chave}>
              <SelectInput name={name} label={chave.label} options={options} />
            </Grid>
          )
        }

        if (chave.dominio.tipo === 'booleano-sn') {
          return (
            <Grid item xs={12} sm={3} key={chave.chave}>
              <SwitchInput name={name} label={chave.label} />
            </Grid>
          )
        }

        return (
          <Grid item xs={12} sm={3} key={chave.chave}>
            <TextInput name={name} label={chave.label} uppercase={false} />
          </Grid>
        )
      })}
    </Grid>
  )
}
